import { create } from 'zustand';

/**
 * "이 사람에게 메일 쓰기" 요청을 메일 화면으로 건네는 한 칸짜리 우편함.
 *
 * 메일 작성 모달은 MailPage 의 지역 상태라 바깥(조직도 팝업)에서 열 수 없다. 모달을 끌어올려
 * 전역화하면 기존 메일 화면을 크게 건드려야 하므로, **받는사람만 담아 두고 MailPage 가 마운트
 * 될 때 한 번 꺼내 쓰는** 방식으로 잇는다(기존 렌더 경로 무수정).
 *
 * 한 번 소비하면 비운다 — 안 그러면 메일 화면에 들어갈 때마다 작성창이 다시 열린다.
 */
export interface PendingMailRecipient {
  id: string;
  name: string;
  email: string;
  position?: string | null;
}

interface MailComposeState {
  pendingTo: PendingMailRecipient | null;
  requestCompose: (to: PendingMailRecipient) => void;
  /** 꺼내면서 비운다. 없으면 null. */
  consume: () => PendingMailRecipient | null;
}

export const useMailComposeStore = create<MailComposeState>((set, get) => ({
  pendingTo: null,
  requestCompose: (to) => set({ pendingTo: to }),
  consume: () => {
    const cur = get().pendingTo;
    if (cur) set({ pendingTo: null });
    return cur;
  },
}));
